export default __webpack_public_path__ + "static/media/MaskGroup309.5737cece.png";